import {gql} from 'apollo-angular';

export const CREATE_SHARED_LINK = gql`
  mutation createSharedLink($payload: String!, $source: SharedLinkSource!) {
    createSharedLink(payload: $payload, source: $source) {
      result
    }
  }
`;

export const SHARED_LINK = gql`
  query sharedLink($id: UUID!) {
    sharedLink(id: $id) {
      payload
      createdAt
    }
  }
`;
